// extracted by mini-css-extract-plugin
module.exports = {"pinInput":"TakeExistingTestPrompt_pinInput__xC7c2"};